module.exports = __webpack_public_path__ + "media/echoes-atch-no-copyright-music.a3766e3e.mp3";